export { default as Curso, Props as CursoProps } from './Curso';
export { default as TodosLosCursos } from './TodosLosCursos';
export * from './HeaderNombreDeCurso';



// WEBPACK FOOTER //
// ./src/modulos/Horarios/componentes/index.ts